/* unplugin-vue-components disabled */import { render } from "./w-text.vue?vue&type=template&id=3f7a40e6&ts=true"
import script from "./w-text.vue?vue&type=script&lang=ts"
export * from "./w-text.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__